import { SliderWithLabels } from '../../Slider';
import { useId } from 'react';
import { INPUT_VALUE_RANGES } from '@/pages/Narrative/utils/validation';
import {
  NarrativeForm,
  VALUATOR_RATE_PRECISION,
} from '@/pages/Narrative/utils/schema';
import { NarrativeMiniValuatorTimePeriodSelector } from './NarrativeMiniValuatorTimePeriodSelector';
import { NarrativeMiniValuatorGrowthRevenueInput } from './NarrativeMiniValuatorGrowthRevenueInput';

type Props = {
  values: NarrativeForm;
  onRevenueChange: (value: number) => void;
  onTimePeriodChange: (value: number) => void;
  onSliderInteraction?: (isInteracting: boolean) => void;
};

export const NarrativeMiniValuatorGrowth = ({
  values,
  onRevenueChange,
  onTimePeriodChange,
  onSliderInteraction,
}: Props) => {
  const sliderId = useId();

  const revenueInputId = useId();

  return (
    <div className="grid grid-cols-[1fr_minmax(auto,150px)] grid-rows-[max-content_max-content] gap-x2">
      <div className="grid grid-cols-[max-content_max-content]">
        <label className="mb-0" htmlFor={revenueInputId}>
          <div className="text-xs font-strong text-solid">
            Growth estimate over
          </div>
          <div className="text-tiny text-soft">Annual revenue growth rate</div>
        </label>
        <div className="-mt-0.5">
          <NarrativeMiniValuatorTimePeriodSelector
            timePeriod={values.timePeriod}
            onChange={onTimePeriodChange}
          />
        </div>
      </div>
      <NarrativeMiniValuatorGrowthRevenueInput
        id={revenueInputId}
        value={values.revenuePercentage}
        onChange={onRevenueChange}
      />

      <div className="col-span-2">
        <SliderWithLabels
          id={sliderId}
          minRange={INPUT_VALUE_RANGES.revenuePercentage.min}
          maxRange={INPUT_VALUE_RANGES.revenuePercentage.max}
          value={values.revenuePercentage}
          precision={VALUATOR_RATE_PRECISION}
          onChange={onRevenueChange}
          onInteraction={onSliderInteraction}
          bands={[
            {
              threshold: 0,
              trackColor: 'var(--s-color-bad)',
              label: 'Decrease',
              align: 'left',
            },
            {
              threshold: 20,
              trackColor: 'var(--s-color-warning)',
            },
            {
              threshold: 300,
              trackColor: 'var(--s-color-good)',
              label: 'Increase',
              align: 'right',
            },
          ]}
        />
      </div>
    </div>
  );
};
